import React, { Component, Fragment } from 'react';
import { Breadcrumbs, Modal, Paper, Typography, withStyles } from '@material-ui/core';
import MaterialTable from 'material-table';
import { Query, withApollo } from "react-apollo";
import {removeSessaoPorId, clonaSessaoPorId, organizadorSessoesEncerradasQuery} from '../../graphql/Sessao';
import autoBind from 'react-autobind';
import { Button, Row, Col, ButtonToolbar, Form } from 'react-bootstrap';
import FindInPageOutlinedIcon from '@material-ui/icons/FindInPageOutlined';
import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import Environment from "../../environment/environment";
import SessaoEncerradaDetalhes from "./encerrada-detalhes";
import Swal from 'sweetalert2';

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
    novaSessaoWrapper: {
        minHeight: '100vh'
    },
    modalWrapper: {
        display: 'flex',
        justifyContent: 'center'
    }
});

class OrgEncerradas extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sessaoSelecionada: null,
            showModalDetalhes: false
        }

        autoBind(this);
    }

    defineDetalhesDaSessaoModal() {
        const { showModalDetalhes, sessaoSelecionada } = this.state;
        const { classes } = this.props;

        return (
            <Modal open={showModalDetalhes} onClose={this.handleClose}>
                <div className={classes.modalWrapper}>
                    <SessaoEncerradaDetalhes session={sessaoSelecionada} handleCloseFnc={this.handleCloseModal} />
                </div>
            </Modal>
        );
    }

    doRefetch() {
        if (!this._queryRefetch) return;

        this.props.client.clearStore().then(
            () => this._queryRefetch(this._queryVariables ? { variables: this._queryVariables } : {})
        );
    }

    geraActions() {
        const actions = [];
        const { client } = this.props;

        actions.push({
            icon: DeleteOutlinedIcon,
            tooltip: 'Excluir',
            onClick: (event, rowData) => {
                Swal.fire({
                    title: '<strong>Confirmar exclusão <u>definitiva</u></strong>',
                    icon: 'warning',
                    html:
                        'Você está prestes à excluir esta sessão. <br/>' +
                        'Esta ação é <b>irreversível</b>.<br/>' +
                        'Confirma?',
                    showCloseButton: false,
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText:
                        '<i class="fa fa-trash"></i> Sim!',
                    confirmButtonAriaLabel: 'Sim!',
                    cancelButtonText:
                        '<i class="fa fa-close"></i>Não',
                    cancelButtonAriaLabel: 'Não',
                    preConfirm: () => {
                        client.mutate({
                            mutation: removeSessaoPorId,
                            variables: {
                                id: rowData.id
                            }
                        }).then(data => {
                            this._queryRefetch();
                        }).catch(ex => {
                            const errorMessage = ex.graphQLErrors.map(e => e.debugMessage).join("\n");
                            Swal.fire({
                                title: "Erro ao excluir sessão",
                                text: errorMessage || "",
                                icon: "error",
                                confirmButtonColor: "#ff0000",
                                showCancelButton: false,
                            });
                        });
                    }
                });
            }
        });

        actions.push({
            icon: FindInPageOutlinedIcon,
            tooltip: 'Detalhes',
            onClick: (event, rowData) => {
                this.setState({
                    sessaoSelecionada: rowData.id,
                    showModalDetalhes: true
                });
            }
        });

        actions.push({
            icon: FileCopyOutlined,
            tooltip: 'Duplicar',
            onClick: (event, rowData) => {
                Swal.fire({
                    title: '<strong>Confirmar duplicação</strong>',
                    icon: 'warning',
                    html:
                        'Você está prestes à duplicar esta sessão. <br/>' +
                        'Confirma?',
                    showCloseButton: false,
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText:
                        '<i class="fa fa-trash"></i> Sim!',
                    confirmButtonAriaLabel: 'Sim!',
                    cancelButtonText:
                        '<i class="fa fa-close"></i>Não',
                    cancelButtonAriaLabel: 'Não',
                    preConfirm: () => {
                        client.mutate({
                            mutation: clonaSessaoPorId,
                            variables: {
                                id: rowData.id
                            }
                        }).then(data => {
                            Swal.fire({
                                title: "Sessão duplicada",
                                text: "Verifique no menu agendadas (hoje + 7 dias).",
                                icon: "success",
                                confirmButtonColor: "#5d5d5d",
                                showCancelButton: false,
                            });
                        }).catch(ex => {
                            const errorMessage = ex.graphQLErrors.map(e => e.debugMessage).join("\n");
                            Swal.fire({
                                title: "Erro ao clonar sessão",
                                text: errorMessage || "",
                                icon: "error",
                                confirmButtonColor: "#ff0000",
                                showCancelButton: false,
                            });
                        });
                    }
                });
            }
        });

        return actions;
    }

    handleCloseModal() {
        this.setState({
            showModalDetalhes: false,
            sessaoSelecionada: null
        });
    }

    renderBreadCrumb() {
        return (
            <Breadcrumbs aria-label="Breadcrumb" className="bradcrumbs">
                <Typography>Organizar</Typography>
                <Typography>Gerenciar Sessões</Typography>
                <Typography>Encerradas</Typography>
            </Breadcrumbs>
        );
    }

    renderGridPrincipal() {
        const actions = this.geraActions();

        return (
            <Query query={organizadorSessoesEncerradasQuery} fetchPolicy='network-only'>
                {({ data, loading, error, refetch }) => {
                    if (loading) return 'Loading...'
                    if (error) return `Error! ${error.message}`
                    this._queryRefetch = refetch;

                    return (
                        <Fragment>
                            <MaterialTable
                                actions={actions}
                                columns={[
                                    { title: "ID", field: "id" },
                                    { title: "Sessão", field: "nome" },
                                    { title: "Início", field: "inicio", render: rowData => Environment.momentToLocalDateAndTimeString(rowData.inicio) },
                                    { title: "Fim", field: "fim", defaultSort: 'desc', render: rowData => Environment.momentToLocalDateAndTimeString(rowData.fim) },
                                ]}
                                data={data.organizadorSessoesEncerradasList}
                                localization={{
                                    body: {
                                        emptyDataSourceMessage: 'Nenhuma sessão encontrada'
                                    },
                                    header: {
                                        actions: 'Ações'
                                    },
                                    toolbar: {
                                        searchPlaceholder: 'Pesquisar',
                                        searchTooltip: 'Pesquisar'
                                    }
                                }}
                                options={{
                                    actionsColumnIndex: -1,
                                    paging: false,
                                    draggable: false
                                }}
                                title={
                                    "Sessões Encerradas"
                                }
                            />
                            {this.defineDetalhesDaSessaoModal()}
                        </Fragment>
                    );
                }}
            </Query>
        );
    }

    render() {
        const { classes } = this.props;

        return (
            <Fragment>
                <Paper className={classes.root}>
                    {this.renderBreadCrumb()}
                    {this.renderGridPrincipal()}
                </Paper>
            </Fragment>
        );
    }


}

export default (withStyles(styles)(withApollo(OrgEncerradas)));